import PropTypes from "prop-types";

import React, { useEffect, useState } from "react";
import noImageAvailable from "../image/No__Image_Available.jpg";

const PLACEHOLDER = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=";

const LazyLoadImage = ({ src, alt, item, handleImageClick }) => {
  const [imageSrc, setImageSrc] = useState(PLACEHOLDER);
  const [imageRef, setImageRef] = useState();
  const [imgIndex, setImgIndex] = useState(0);

  const onLoad = (event) => {
    event.target.classList.add("loaded_baijnath");
  };

  const onError = (event) => {
    event.target.src = noImageAvailable;
  };

  useEffect(() => {
    let observer = null;
    let didCancel = false;

    if (imageRef && imageSrc !== src) {
      if (IntersectionObserver) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (
                !didCancel &&
                (entry.intersectionRatio > 0 || entry.isIntersecting)
              ) {
                setImageSrc(src);
                observer.unobserve(imageRef);
              }
            });
          },
          {
            threshold: 0.4,
            rootMargin: "75%",
          },
        );
        observer.observe(imageRef);
      } else {
        // Old browsers fallback
        setImageSrc(src);
      }
    }
    return () => {
      didCancel = true;
      // on component cleanup, we remove the listner
      if (observer && observer.unobserve) {
        observer.unobserve(imageRef);
      }
    };
  }, [src, imageRef]);

  return (
    <img
      referrerPolicy="strict-origin-when-cross-origin"
      ref={setImageRef}
      src={imageSrc}
      alt={alt}
      style={{ objectFit: "contain" }}
      onLoad={onLoad}
      className="card-img-top"
      onError={onError}
      onClick={() => handleImageClick(item)}
    />
  );
}

LazyLoadImage.propTypes = {
  src: PropTypes.any,
  alt: PropTypes.any,
  item: PropTypes.any,
  handleImageClick: PropTypes.func,
};

export default LazyLoadImage;
